const LANGUAGES = [
  "All languages",
  "adlam",
  "ahom",
  "anatolian-hieroglyphs",
  "arabic",
  "armenian",
  "avestan",
  "balinese",
  "bamum",
  "bassa-vah",
  "batak",
  "bengali",
  "bhaiksuki",
  "brahmi",
  "buginese",
  "buhid",
  "canadian-aboriginal",
  "carian",
  "caucasian-albanian",
  "chakma",
  "cham",
  "cherokee",
  "chinese-hongkong",
  "chinese-simplified",
  "chinese-traditional",
  "coptic",
  "cuneiform",
  "cypriot",
  "cyrillic",
  "cyrillic-ext",
  "deseret",
  "devanagari",
  "dogra",
  "duployan",
  "egyptian-hieroglyphs",
  "elbasan",
  "elymaic",
  "emoji",
  "ethiopic",
  "georgian",
  "glagolitic",
  "gothic",
  "grantha",
  "greek",
  "greek-ext",
  "gujarati",
  "gunjala-gondi",
  "gurmukhi",
  "hanifi-rohingya",
  "hanunoo",
  "hatran",
  "hebrew",
  "imperial-aramaic",
  "indic-siyaq-numbers",
  "inscriptional-pahlavi",
  "inscriptional-parthian",
  "japanese",
  "javanese",
  "kaithi",
  "kannada",
  "kayah-li",
  "kharoshthi",
  "khmer",
  "khojki",
  "khudawadi",
  "korean",
  "lao",
  "latin",
  "latin-ext",
  "lepcha",
  "limbu",
  "linear-a",
  "linear-b",
  "lisu",
  "lycian",
  "lydian",
  "mahajani",
  "malayalam",
  "mandaic",
  "manichaean",
  "marchen",
  "masaram-gondi",
  "math",
  "mayan-numerals",
  "medefaidrin",
  "meetei-mayek",
  "menu",
  "meroitic",
  "miao",
  "modi",
  "mongolian",
  "mro",
  "multani",
  "music",
  "myanmar",
  "nabataean",
  "new-tai-lue",
  "newa",
  "nko",
  "nushu",
  "nyiakeng-puachue-hmong",
  "ogham",
  "ol-chiki",
  "old-hungarian",
  "old-italic",
  "old-north-arabian",
  "old-permic",
  "old-persian",
  "old-sogdian",
  "old-south-arabian",
  "old-turkic",
  "oriya",
  "osage",
  "osmanya",
  "pahawh-hmong",
  "palmyrene",
  "pau-cin-hau",
  "phags-pa",
  "phoenician",
  "psalter-pahlavi",
  "rejang",
  "runic",
  "samaritan",
  "saurashtra",
  "sharada",
  "shavian",
  "siddham",
  "sinhala",
  "sogdian",
  "sora-sompeng",
  "soyombo",
  "sundanese",
  "syloti-nagri",
  "symbols",
  "syriac",
  "tagalog",
  "tagbanwa",
  "tai-le",
  "tai-tham",
  "tai-viet",
  "takri",
  "tamil",
  "tamil-supplement",
  "tangut",
  "telugu",
  "thaana",
  "thai",
  "tibetan",
  "tifinagh",
  "tirhuta",
  "ugaritic",
  "vai",
  "vietnamese",
  "wancho",
  "warang-citi",
  "yezidi",
  "yi",
  "zanabazar-square",
];
// const LANGUAGES = [
//   "All languages",
//   "Arabic",
//   "Bengali",
//   "Chinese (Hong Kong)",
//   "Chinese (Simplified)",
//   "Chinese (Traditional)",
//   "Cyrillic Extended",
//   "Cyrillic",
//   "Devanagari",
//   "Greek Extended",
//   "Greek",
//   "Gujarati",
//   "Gurmukhi",
//   "Hebrew",
//   "Japanese",
//   "Kannada",
//   "Khmer",
//   "Korean",
//   "Latin Extended",
//   "Latin",
//   "Malayalam",
//   "Myanmar",
//   "Oriya",
//   "Sinhala",
//   "Tamil",
//   "Telugu",
//   "Thai",
//   "Tibetan",
//   "Vietnamese",
// ];

const CATEGORIES = [
  "Serif",
  "Sans Serif",
  "Display",
  "Handwriting",
  "Monospace",
];

const SORT_OPTIONS = ["name", "most Popular"];

const META_URL = "https://fonts.google.com/metadata/fonts";

export { LANGUAGES, CATEGORIES, SORT_OPTIONS };
